/**
 * WebSocket `close` event codes (RFC 6455). 1005/1006 are reserved in frames but used by clients for synthetic closes.
 */
export function describeWebSocketCloseCode(code: number): string {
  const known: Record<number, string> = {
    1000: 'normal closure',
    1001: 'going away',
    1002: 'protocol error',
    1003: 'unsupported data',
    1005: 'no status (reserved)',
    1006: 'abnormal closure — often network loss, proxy, or idle timeout (no close frame)',
    1007: 'invalid payload data',
    1008: 'policy violation',
    1009: 'message too big',
    1010: 'mandatory extension',
    1011: 'internal server error',
    1012: 'service restart',
    1013: 'try again later',
    1014: 'bad gateway',
    1015: 'TLS handshake failed',
  };
  if (known[code]) return known[code]!;
  if (code >= 3000 && code <= 3999) return 'registered (framework)';
  if (code >= 4000 && code <= 4999) return 'application-specific';
  return 'non-standard';
}

export function formatWebSocketClose(
  label: string,
  code: number,
  reason: string,
  extra?: string,
): string {
  const r = reason.trim();
  const reasonPart = r ? ` reason="${r}"` : '';
  const extraPart = extra ? ` ${extra}` : '';
  return `${label} Disconnected: code=${code} (${describeWebSocketCloseCode(code)})${reasonPart}${extraPart}`;
}
